module.exports = __webpack_public_path__ + "img/Group 739.95be49b5.svg";